import axios from '@/axios'

export async function paymentIntent(request) {
  const response = await axios.post('payment/intent', request)
  return response.data
}

export function xxx() {}
